module.exports = __webpack_public_path__ + "img/zh.ff295a2c.png";